import { render, staticRenderFns } from "./YoutubePlayerGraphql.vue?vue&type=template&id=4c92213a"
import script from "./YoutubePlayerGraphql.vue?vue&type=script&lang=ts"
export * from "./YoutubePlayerGraphql.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports